import React, { PureComponent } from "react";
import classnames from "classnames";
import _ from "i18n";

import { getFormatNumber } from "Utils";
import { SIGN, STATUS } from "Config";

import { Tooltip } from "antd";
import { ICONS, SvgIcon, StatisticsIcon } from "../Common/Icons";
import PercentageStatus from "../Common/Percentage/PercentageStatus";
import { getUserNameForAvatar } from "Utils";
import styles from "./Item.local.scss";

class Item extends PureComponent {
  renderClient() {
    let { item, erpData } = this.props;
    let erpCollaborators = erpData && erpData.items.collaborators;
    const dataErp = erpCollaborators ? erpCollaborators : [];

    let avatarDiv = null;
    if (item.avatarUrl) {
      avatarDiv = (
        <div
          className={classnames(styles.user_avatar, "employee")}
          style={{ backgroundImage: `url(${item.avatarUrl})` }}
        />
      );
    } else {
      avatarDiv = (
        <div
          className={classnames(styles.user_avatar, "empty-avatar", "employee")}
        >
          <span className="empty-avatar__initials">
            {item.firstName && item.lastName
              ? getUserNameForAvatar(item.firstName, item.lastName)
              : getUserNameForAvatar(item.name, "")}
          </span>
        </div>
      );
    }
    return (
      <div
        key={item.key}
        className={`${styles.list_item}  border-${item.colorClass}`}
      >
        <div className={`medium-1 ${styles.check}`}>{avatarDiv}</div>
        <div
          className="medium-2"
          style={{ marginLeft: "-2%", marginRight: "2%", marginTop: "20px" }}
        >
          <div className={styles.list_item__header}>
            <p
              style={{
                textDecoration: item["isDeleted"] ? "line-through" : "",
                marginBottom: 0
              }}
            >
              {" "}
              {item.firstName && item.lastName
                ? item.firstName + " " + item.lastName
                : item.name}
            </p>
            {dataErp.map(erp => {
              return erp[item.id] && erp[item.id].erpId ? (
                <Tooltip
                  key={`key-tool-${item.id}`}
                  placement="right"
                  title={
                    <div>
                      <p>
                        {_("importedFrom")} : {erp[item.id].erpLabel}
                      </p>
                      <p>
                        {_("identifier")} : {erp[item.id].erpId}
                      </p>
                    </div>
                  }
                >
                  {" "}
                  <img
                    src="/img/icons/info.svg"
                    alt="text"
                    className={styles.img_info}
                  />{" "}
                </Tooltip>
              ) : (
                ""
              );
            })}
          </div>
          <div className={styles.list_item__sub_header}>{item.role}</div>
          <div className={styles.list_item__sub_header_2}>
            {item.regime} • {_("capacity")}:{" "}
            {getFormatNumber(parseFloat(item.capacity).toFixed(2))}
          </div>
          <div className={styles.list_item__header}>
            {item.states &&
              item.states.map((state, i) => {
                return (
                  <Tooltip
                    key={`${item.id}-${i}`}
                    placement="bottom"
                    title={_(state.comment)}
                  >
                    <span>
                      <i
                        className={`bg-${
                          state.value === STATUS.ACCEPTED ? "success" : "alert"
                        }`}
                      />
                    </span>
                  </Tooltip>
                );
              })}
          </div>
        </div>

        <div className={`medium-1 ${styles.list_item__key}`}>
          <div data-for={`aab__${item.id}`} data-tip={"Net assets"}>
            <span>
              {getFormatNumber(item.affectedBudget.value)}
              {"H"}
            </span>
            <br />
            <span className={styles.percentage_diff}>
              <PercentageStatus payload={item.affectedBudget} />
            </span>
            <div>{_("AnnualAffectedBudget")}</div>
          </div>
        </div>
        <div className={`medium-1 ${styles.list_item__key}`}>
          <div
            data-for={`obc__${item.id}`}
            data-tip={"Degree of financial independence"}
          >
            <span>
              {getFormatNumber(item.outBudget.value)}
              {"H"}
            </span>
            <br />
            <span className={styles.percentage_diff}>
              <PercentageStatus payload={item.outBudget} />
            </span>
            <div>{_("OutBudgetCompletion")}</div>
          </div>
        </div>
        <div className={`medium-1 ${styles.list_item__key}`}>
          <div data-for={`ba__${item.id}`} data-tip={"Current ratio"}>
            <span>
              {item.availability.sign === SIGN.NEGATIVE && "-"}
              {getFormatNumber(item.availability.value)}
              {"H"}
            </span>
            <br />
            <span className={styles.percentage_diff}>
              <PercentageStatus payload={item.availability} />
            </span>
            <div>{_("BudgetaryAvailability")}</div>
          </div>
        </div>
        <div className={`medium-1 ${styles.list_item__key}`}>
          <div data-for={`ba__${item.id}`} data-tip={"Current ratio"}>
            <span>
              {getFormatNumber(item.annualReleased.value)}
              {"H"}
            </span>
            <br />
            <span className={styles.percentage_diff}>
              <PercentageStatus payload={item.annualReleased} />
            </span>
            <div>{_("AnnualReleasedCompletion")}</div>
          </div>
        </div>
        <div className={`medium-1 ${styles.list_item__key}`}>
          <div data-for={`ba__${item.id}`} data-tip={"Current ratio"}>
            <span>
              {getFormatNumber(item.currentReleased.value)}
              {"H"}
            </span>
            <br />
            <span className={styles.percentage_diff}>
              <PercentageStatus payload={item.currentReleased} />
            </span>
            <div>{_("CurrentReleasedCompletion")}</div>
          </div>
        </div>

        <div
          className={classnames("medium-2", styles.flex_container)}
          style={{ marginLeft: "-0.5%" }}
        >
          <div className={styles.list__row_groups_cell_wrapper}>
            <div className={classnames(styles.groups_block_position)}>
              <span
                className={styles.list__row_group_cell_tag}
                style={{ fontWeight: 400 }}
              >
                {_("dossierCount")} :{" "}
                {item.outBudget.exception +
                  (item.outBudget.remark
                    ? parseInt(item.outBudget.remark.params, 10)
                    : 0)}
              </span>
              <span className={styles.list__row_group_cell_tag}>
                {parseInt(item.outBudget.exception, 10)} {_("budgeted")}
              </span>
              <span className={styles.list__row_group_cell_tag}>
                {item.outBudget.remark
                  ? parseInt(item.outBudget.remark.params, 10)
                  : 0}{" "}
                {_("nonBudgeted")}
              </span>
            </div>
          </div>
        </div>
        <div
          className={classnames("medium-1", styles.flex_container)}
          style={{ marginLeft: "-2%", marginRight: "2%" }}
        >
          <div className={styles.presentation_info_container}>
            <div className={classnames(styles.presentation_date)}>
              <img alt={""} src={"/img/icons/calendar.svg"} />
              <span>Indicateurs bilan</span>
            </div>
            <div className={classnames(styles.presentation_prepared)}>
              <img alt={""} src={"/img/icons/presentation.svg"} />
              <span>
                <b>{_("indicateurs bilan")}</b>
              </span>
            </div>
          </div>
        </div>
        <div className="medium-1">
          <div className={styles.list_item__actions}>
            <Tooltip
              key="tool-1"
              placement="bottom"
              title={_("Details")}
              mouseLeaveDelay={0}
            >
              <div
                onClick={() =>
                  this.props.handleRedirectCapacityCollaborator(item)
                }
              >
                <StatisticsIcon />
              </div>
            </Tooltip>
            <Tooltip
              key="tool-2"
              placement="bottom"
              title={_("Calendar")}
              mouseLeaveDelay={0}
            >
              <div
                onClick={() =>
                  this.props.handleRedirectCalendarCollaborator(item)
                }
              >
                <SvgIcon icon={ICONS.CALENDAR} />
              </div>
            </Tooltip>
            <Tooltip
              key="tool-3"
              placement="bottom"
              title={_("capacityPlaning")}
              mouseLeaveDelay={0}
            >
              <div
                onClick={() =>
                  this.props.handleRedirectCollaboratorCalendarTable(
                    item.id,
                    item.name
                  )
                }
              >
                <SvgIcon icon={ICONS.TIME_SHEET_PAGE_ICON} />
              </div>
            </Tooltip>
            <Tooltip
              key="tool-4"
              placement="bottom"
              title={_("Configuration")}
              mouseLeaveDelay={0}
            >
              <div
                onClick={() => this.props.handleRedirectCollaboratorSetting()}
              >
                <SvgIcon icon={ICONS.SETTING} />
              </div>
            </Tooltip>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return this.renderClient();
  }
}

export default Item;



// WEBPACK FOOTER //
// ./src/components/CapacityPlanning/Item.js